// @ts-nocheck

import classNames from 'classnames';
import * as React from 'react';
import Tooltip from '../../common/components/core/Tooltip';
import { AuthCheckboxLabel } from './AuthCheckboxLabel';
type Props = {
  /**
   * checked status (state maintained by parent)
   */
  checked?: boolean;

  /**
   * used for input id & data-testid. NOTE: must be unique for each checkbox
   * on the page or they will not work independently.
   */
  id: string;

  /**
   * custom className for outer div
   */
  className?: string;

  /**
   * disable checked status change
   */
  disabled?: boolean;

  /**
   * tooltip to show on hover of a disabled checkbox. Will only appear when
   * 'disabled' field is true.
   */
  disabledTooltip?: string | React.ReactElement<any>;

  /**
   * whether clicking a label checks the box.
   * if this prop is set to true, selecting a label will have no affect on the state of the checkbox
   */
  labelClickDisabled?: boolean;

  /**
   * label is what will appear to the right of the checkbox, and can be
   * a string or an element.
   */
  label?: React.ReactNode;

  /**
   * custom className for label
   */
  labelClassName?: string;

  /**
   * access checked value in callback with e.target.checked
   */
  onChange?: (ev: any) => void;

  /**
   * if tooltip and label passed in, an info icon will appear inline next
   * to the label.
   */
  tooltip?: string | React.ReactElement<any>;

  /**
   * This prop is passed down from the ScreenSignup component to match the onBlur validation on the
   * rest of the Sign Up form.
   * The T&C tickbox wasn't being included in the tab index without applying onBlur directly here.
   */
  onBlur?: () => void;
};

class AuthCheckbox extends React.PureComponent<Props> {
  getContent = () => {
    const props = this.props;
    const checkbox = (
      <div className="checkbox-container">
        <input
          className="auth_check_box--input"
          checked={props.checked}
          disabled={props.disabled}
          id={`${props.id}-checkbox`}
          name="check"
          onChange={props.onChange}
          type="checkbox"
          onBlur={props.onBlur}
        />
        <i className="material-icons">{props.checked ? 'check_box' : 'check_box_outline_blank'}</i>
        <AuthCheckboxLabel
          className={props.labelClassName}
          label={props.label}
          tooltip={props.tooltip}
          disabled={props.disabled}
          id={props.id}
          labelClickDisabled={props.labelClickDisabled}
        />
      </div>
    );

    if (props.disabled && props.disabledTooltip) {
      return <Tooltip body={props.disabledTooltip}>{checkbox}</Tooltip>;
    }

    return checkbox;
  };

  render() {
    // New checkbox design uses material icons icon for checkbox.
    // Have kept the input element to provide feedback of tick, but it is made invisible with CSS.
    return (
      <div
        data-testid={`${this.props.id}-checkbox`}
        className={classNames('auth_check_box', this.props.className)}
        bindClickEvent={true}
      >
        {this.getContent()}
      </div>
    );
  }
}

export default AuthCheckbox;
